
  <nav class="w-full bg-white border-b border-gray-200">
    <div class=" mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between h-16">
        <div class="flex">
          <div class="flex-shrink-0 flex items-center">
            <span class="font-bold text-lg">RFI</span>
          </div>
          <!-- Nav Tabs -->
          <div class="hidden sm:ml-6 sm:flex sm:space-x-8">
            <button
              (click)="setActiveTab('items')"
              [ngClass]="{'border-orange-500 text-orange-600': activeTab === 'items', 'border-transparent text-gray-500': activeTab !== 'items'}"
              class="inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
            >
              Items
            </button>
            <button
              (click)="setActiveTab('recycle')"
              [ngClass]="{'border-orange-500 text-orange-600': activeTab === 'recycle', 'border-transparent text-gray-500': activeTab !== 'recycle'}"
              class="inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
            >
              Recycle Bin
            </button>
          </div>
          
        </div>

        <div class="flex items-center">
          <button class="close-button !mr-[10px]">
            Export
            <svg
            width="11"
            height="5"
            viewBox="0 0 11 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
           
          >
            <path d="M0 0L5.1461 5L10.2922 0H0Z" fill="#E76B3F" />
          </svg>
          </button>
          <button class="close-button">
            Reports
            <svg
            width="11"
            height="5"
            viewBox="0 0 11 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
           
          >
            <path d="M0 0L5.1461 5L10.2922 0H0Z" fill="#E76B3F" />
          </svg>
          </button>
          <button
          class="!bg-[#E76B3F] !text-[#ffffff] p-[14px] !pl-[10px] font-bold !text-[14px] flex h-[38px] w-fit items-center flex-shrink-0 hover:bg-white rounded-[3px] shadow-md ml-[15px] text-center"
          (click)="navigateTo()"
          >
        <mat-icon class="mt-[5px] font-bold" >add</mat-icon>
          Create 
        </button>
        </div>
      </div>
    </div>
  </nav>
  
  <!-- search-filter.component.html -->
  <div class="w-full  mx-auto px-4 sm:px-6 lg:px-8 mt-4">
    <div class="flex items-center ">
        <div class="relative w-full max-w-xs">
            <input 
              type="text" 
              placeholder="Search" 
              class="block w-full pl-3 pr-10 py-2 border border-gray-300 rounded-[3px] leading-5 bg-white sm:text-sm" 
            />
            <div class="absolute inset-y-0 right-0 pr-3 flex items-center">
              <mat-icon matSuffix>search</mat-icon>
            </div>
          </div>
          
      <button class="ml-3 px-4 py-2 border flex border-gray-300 shadow-sm text-sm font-medium rounded-[3px] text-[#000] bg-white hover:bg-gray-50">
        Add Filters 
        <svg
        width="11"
        height="5"
        viewBox="0 0 11 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="ml-[10px] mt-[7px]"
       
      >
        <path d="M0 0L5.1461 5L10.2922 0H0Z" fill="#000" />
      </svg>
      </button>
    </div>
  </div>
  
  <!-- no-rfi.component.html -->
  <div class="flex flex-col items-center justify-center flex-grow mt-[1.5rem]">
    <img src="/assets/icons/empty-folder.svg" alt="No RFI Found" class="w-48 h-48" >   
    <p class="mt-4 text-lg font-semibold text-gray-700">No RFI Found</p>
  </div>
  